import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M5M3 (庫存交運清單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fm130_01: string;       // 交運清單號
  fm130_11: string;       // 交運日期 (YYYY-MM-DD)
  fm130_16: string;       // 客戶代碼
  fm130_20: string;       // 部門代碼
  fm130_22: string;       // 負責人
  fm130_80: string;       // 狀態 (P=核准)
  customer_name: string;  // 客戶名稱 (lookup)
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const m5m3Api = {
  /** Query delivery list candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/m5m3/candidates', { params });
    return res.data;
  },

  /** Execute batch approval reversal for selected delivery lists */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/m5m3/reverse', { items, confirmed: true });
    return res.data;
  },
};
